enum PopulationBasedFundingStatusIcon {
    Unknown,
    NotRegistered = "img_icon_not_registered",
    NotRegisteredButReceiveTreatment = "img_icon_not_registered_but_receive_treatment",
    RegisteredToDifferentPhysician = "img_icon_registered_to_different_physician",
    Registered = "img_icon_registered",
    RegisteredToAnotherPbfPayee = "img_icon_registered_to_another_pbf_payee",
    PendingRegistration = "img_icon_pending_registration",
    PendingDeregistration = "img_icon_pending_deregistration",
    RegisteredToAnotherPbfPayeeWithinTheSameReportingGroup = "img_icon_another_physician_within_same_reporting_group"
}

export { PopulationBasedFundingStatusIcon };
